"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _SvgIcon = _interopRequireDefault(require("./SvgIcon"));

var _styles = require("../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var styles = {
  root: {
    height: function height(_ref) {
      var _height = _ref.height;
      return _height;
    },
    width: function width(_ref2) {
      var _width = _ref2.width;
      return _width;
    },
    fill: function fill(_ref3) {
      var color = _ref3.color;
      return color;
    },
    stroke: function stroke(_ref4) {
      var enableStroke = _ref4.enableStroke,
          color = _ref4.color;
      return enableStroke ? color : '';
    },
    flexShrink: 0,
    flexGrow: 0
  }
};

function createSvgIcon(SvgContents, svgProps) {
  var SvgIcon = function SvgIcon(_ref5) {
    var classes = _ref5.classes,
        enableStroke = _ref5.enableStroke,
        height = _ref5.height,
        width = _ref5.width,
        color = _ref5.color,
        props = _objectWithoutProperties(_ref5, ["classes", "enableStroke", "height", "width", "color"]);

    return _react["default"].createElement(_SvgIcon["default"], _extends({
      className: classes.root
    }, props), _react["default"].createElement(SvgContents, null));
  };

  SvgIcon.defaultProps = _objectSpread({
    height: '15px',
    width: '15px',
    color: _styles.colors.black
  }, svgProps);
  SvgIcon.InnerComponent = SvgContents;
  SvgIcon.displayName = "SvgIcon(".concat(SvgContents.name, ")");
  return (0, _withStyles["default"])(styles)(SvgIcon);
}

var _default = createSvgIcon;
exports["default"] = _default;